export const clearStorageData = () => {
  try {
    sessionStorage.clear();
    sessionStorage.clear();
  } catch (error) {
    console.error("Error clearing storage data:", error);
  }
};
